import './style.scss';

import React from 'react';

const StrengthCircles = ({ strength, diameter = 20, style = {} }) => {
  const getCircleColor = (index) => {
    if (index >= strength) {
      return '#e0e0e0'; // Color for circles beyond the given strength
    }

    const colors = [
      '#ffc107', // Strength 1 - Mellow
      '#ff9333', // Strength 2 - Mellow-Medium
      '#ff5851', // Strength 3 - Medium
      '#f23d41', // Strength 4 - Mellow-Full
      '#dc3545', // Strength 5 - Full
    ];

    return colors[index];
  };

  const circles = Array.from({ length: 5 }, (_, index) => (
    <div
      key={index}
      className="circle"
      style={{
        backgroundColor: getCircleColor(index),
        width: `${diameter}px`,
        height: `${diameter}px`,
      }}
    />
  ));

  return (
    <div className="strength-circles" style={style}>
      {circles}
    </div>
  );
};

export default StrengthCircles;
